export default "__VITE_ASSET__CNhdC7y7__"